import React from 'react';
import { Typography } from 'antd';
import FertilizationPHChart from '../../../Helpers/Charts/FertilizationPHChart';
import FertilizationECChart from '../../../Helpers/Charts/FertilizationECChart';

const { Title, Text } = Typography;

const FertilizationChartSection = ({ data }) => {
  return (
    <section>
      <Title level={3} className="text-xl md:text-2xl font-semibold mb-4">Données de fertilisation</Title>
      <Text className="mb-4 block">Les graphiques ci-dessous présentent les niveaux de pH et de conductivité électrique (EC) liés à la fertilisation.</Text>
      <div className="space-y-6">
        <div>
          <Title level={4} className="text-lg md:text-xl font-semibold mb-2">Niveaux de pH</Title>
          <FertilizationPHChart data={data} />
        </div>
        <div>
          <Title level={4} className="text-lg md:text-xl font-semibold mb-2">Niveaux de conductivité électrique (EC)</Title>
          <FertilizationECChart data={data} />
        </div>
      </div>
    </section>
  );
};

export default FertilizationChartSection;